import { Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
export default function StationNowPlaying({ info }) {
  const { t } = useTranslation();
  if (!info || !info.is_song) return null;

  return (
    <Flex justify="center">
      <Text size="xs" c="dimmed" align="center">
        {t("user_app:now_playing_title")}: {info.name}{" "}
        {t("common:by")?.toLowerCase()} {info.artist}
      </Text>
    </Flex>
  );
}
